<template>
    <div>
        <div class="col-12">
            <button class="btn btn-link custom-no-padding-btn " @click="returnToSelectList" type="button">
                <i class="fa fa-chevron-left"></i>
            </button>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="wfh-selector-new" class="form-label">
                    {{ title ? 'Goal' : 'Label' }} Name
                </label>
                <input
                    type="text"
                    id="wfh-selector-new"
                    class="form-control"
                    v-model="editedItem.name"
                    @keydown.enter="submitItem"
                />
            </div>
        </div>
        <div class="col-12 d-flex justify-content-center py-2">
            <button
                type="button"
                class="btn btn-outline-dark btn-width mr-2"
                @click="cancelOrDelete"
            >
                {{ cancelText }}
            </button>
            <button
                type="button"
                class="btn wfh-btn-primary btn-width"
                :disabled="!editedItem.name || editedItem.name === item.name"
                @click="submitItem"
            >
                {{ submitText }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ManageItem',

    props: ['item', 'title'],

    data () {
        return {
            editedItem: {
                id: null,
                name: null,
            },
        };
    },

    computed: {
        submitText () {
            return this.editedItem.itemId !== null ? 'Save Changes' : 'Create';
        },

        cancelText () {
            return !!this.editedItem.id ? 'Delete' : 'Cancel';
        },
    },

    methods: {
        cancelOrDelete () {
            this.editedItem = {
                id: null,
                name: null,
            };

            if (!!this.item.id) {
                this.$emit('deleteItem', this.item.id);
            } else {
                this.returnToSelectList();
            }
        },

        returnToSelectList () {
            this.editedItem = {
                id: null,
                name: null
            };
            this.$emit('returnToSelectList');
        },

        submitItem () {
            this.$emit('updateItem', this.editedItem.name, this.editedItem.id);
            this.returnToSelectList();
        },
    },

    mounted () {
        this.editedItem = {
            id: this.item.id ?? null,
            name: this.item.name ?? this.item ?? null,
        };
    }
};
</script>

<style scoped>
.custom-no-padding-btn {
    padding: 8px 0 !important;
    color: #000 !important;
}
.btn-width {
    min-height: auto;
    width: 150px;
}
</style>
